import familyImg from "@/assets/Banner/indian-kids-with-parents-grandparents-sitting-isolated-white-background-studio-shot 1.png";
import iconsTop from "@/assets/Banner/Frame 11.png";
import iconsBottom from "@/assets/Banner/Frame 12.png";
import vectorLines from "@/assets/Banner/Vector 1.png";

/**
 * Patient App banner — family photo at center with healthcare icons orbiting
 * and connecting lines radiating outward, matching the design reference (img 1).
 */
export default function PatientBanner() {
  return (
    <div className="relative w-full max-w-[680px] mx-auto aspect-square select-none">

      {/* Connecting lines from center to icons */}
      <img
        src={vectorLines}
        alt=""
        aria-hidden="true"
        className="absolute inset-[5%] w-[90%] h-[90%] object-contain pointer-events-none opacity-60"
        draggable="false"
      />

      {/* Top row healthcare icons */}
      <img
        src={iconsTop}
        alt=""
        aria-hidden="true"
        className="absolute top-0 left-0 w-full h-auto pointer-events-none"
        draggable="false"
      />

      {/* Bottom row healthcare icons */}
      <img
        src={iconsBottom}
        alt=""
        aria-hidden="true"
        className="absolute bottom-0 left-0 w-full h-auto pointer-events-none"
        draggable="false"
      />

      {/* Family photo — centered */}
      <img
        src={familyImg}
        alt="Happy Indian family with healthcare icons"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[78%] h-auto object-contain pointer-events-none"
        draggable="false"
      />
    </div>
  );
}
